import React from "react";
import myImage from "../img/myImage.png";

class About extends React.Component {
  constructor() {
    super();
    this.state = {
      skills: [
        { id: "HTML5_skill", content: "HTML5", porcentage: "80%", value: "80" },
        { id: "CSS3_skill", content: "CSS3", porcentage: "75%", value: "75" },
        { id: "SCSS_skill", content: "SCSS", porcentage: "75%", value: "75" },
        {
          id: "JavaScript_skill",
          content: "JavaScript",
          porcentage: "90%",
          value: "90"
        },
        // {
        //   id: "Dart_skill",
        //   content: "Dart",
        //   porcentage: "70%",
        //   value: "70"
        // },
        { id: "React Native", content: "React Native", porcentage: "90%", value: "90" },
        {
          id: "ReactJS_skill",
          content: "ReactJS",
          porcentage: "80%",
          value: "80"
        },
        {
          id: "NextJS_skill",
          content: "NextJS",
          porcentage: "70%",
          value: "70"
        },
        {
          id: "Firebase",
          content: "Firebase",
          porcentage: "80%",
          value: "80"
        },
        // {
        //   id: "Flutter_Skills",
        //   content: "Flutter",
        //   porcentage: "75%",
        //   value: "75"
        // },
      ],
      about_me: [
        {
          id: "first-p-about",
          content:
            "As a skilled developer, I specialize in using cutting-edge technologies like React Native, Flutter, Node.js, and Firebase to deliver dynamic and user-friendly mobile applications."
        },
        {
          id: "second-p-about",
          content:
            "React Native and Flutter are the robust framework that enables me to build apps for both iOS and Android platforms with a single codebase, reducing time and development costs. Additionally, my expertise with node.js and Firebase allow me to create real-time apps that offer robust features like authentication, storage, and database management."
        },
        {
          id: "third-p-about",
          content:
            "With these skills, I can help you create custom applications that meet your unique business needs and exceed your expectations."
        }
      ]
    };
  }

  render() {
    return (
      <section id="about" className="about-mf sect-pt4 route">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="box-shadow-full">
                <div className="row">
                  {/* <div className="col-md-6">
                    <div className="row">
                      <div
                        className="col-sm-6 col-md-5"
                        style={{ margin: "0 auto" }}
                      >
                        <div
                          className="about-img"
                          style={{ textAlign: "center" }}
                        >
                          <img
                            className="img-fluid rounded b-shadow-a"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div className="skill-mf">
                      <p className="title-s">Skills</p>
                      {this.state.skills.map(skill => {
                        return (
                          <React.Fragment key={skill.id}>
                            <span>{skill.content}</span>{" "}
                            <span className="pull-right">
                              {skill.porcentage}
                            </span>
                            <div className="progress">
                              <div
                                className="progress-bar"
                                role="progressbar"
                                style={{ width: skill.porcentage }}
                                aria-valuenow={skill.value}
                                aria-valuemin="0"
                                aria-valuemax="100"
                              ></div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div> */}
                  <div className="col-md-11">
                    <div className="about-me pt-4 pt-md-0">
                      <div className="title-box-2">
                        <h5 className="title-left">About Me</h5>
                      </div>
                      {this.state.about_me.map(content => {
                        return (
                          <p className="lead" key={content.id}>
                            {content.content}
                          </p>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
